import { isValidColor, swatch, saturate } from "colorizr"

export const generateGradientColors = (primaryColor: string): string[] => {
  const defaultGradient = ["#FF3D9A", "#7638FA", "#3A40F5"]

  try {
    if (!isValidColor(primaryColor)) {
      return defaultGradient
    }

    const colorSwatch = swatch(primaryColor)

    return [
      saturate(colorSwatch["600"], 20),
      saturate(colorSwatch["500"], 20),
      saturate(colorSwatch["700"], 20),
    ]
  } catch (error) {
    console.error("Error generating gradient:", error)

    return defaultGradient
  }
}

/**
 * Calculate circle circumferences and segment patterns
 */
export const calculateDashArray = (radius: number, segments: number) => {
  const circumference = 2 * Math.PI * radius
  const baseSegmentLength = circumference / segments

  // Create segments with varying sizes
  const pattern: string[] = []
  for (let i = 0; i < segments; i += 1) {
    const variation1 = Math.sin((i / segments) * Math.PI * 2)
    const variation2 = Math.cos(((i + 0.5) / segments) * Math.PI * 2)
    const segmentVariation = 0.55 + (variation1 + variation2) * 0.15

    const segmentLength = baseSegmentLength * segmentVariation
    const gapLength = baseSegmentLength - segmentLength
    pattern.push(`${segmentLength} ${gapLength}`)
  }

  return pattern.join(" ")
}
